import { render, staticRenderFns } from "./SocialNetwork.vue?vue&type=template&id=4c1f8d16&scoped=true&"
import script from "./SocialNetwork.vue?vue&type=script&lang=js&"
export * from "./SocialNetwork.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetwork.vue?vue&type=style&index=0&id=4c1f8d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f8d16",
  null
  
)

export default component.exports